/* eslint-disable no-restricted-globals */
import React, { useRef, useEffect } from "react";
import { GlobalStyles, theme } from "styles";
import { ThemeProvider } from "styled-components";
import AppRoutes from "./Routes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useInterval } from "hooks/useInterval";
import {
  checkForNewNotifications,
  fetchUnreadNotificationsSuccess,
} from "redux/slices/notifications/notificationsSlice";
import Toast from "components/ui/Toast";
import GlobalSnackbar from "components/common/GlobalSnackbar";
import GlobalLoading from "components/common/GlobalLoading";
import { useLatestWebviewVersion } from "hooks/useLatestWebviewVersion";
import { updatePartnerInfo } from "redux/slices/partner/partnerSlice";

const App = () => {
  useLatestWebviewVersion();

  const exitAppRef = useRef(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useInterval(() => {
    dispatch(checkForNewNotifications());
  }, 60000);

  useEffect(() => {
    // iOS
    window.addEventListener("message", ({ data }) => {
      if (typeof data === "string" && data.includes("notification")) {
        const objData = JSON.parse(data);
        if (objData?.name === "notification") {
          dispatch(fetchUnreadNotificationsSuccess(objData.notiCount));
          if (objData.isNavi) {
            navigate(objData.target);
          }
        }
      }
    });

    // AOS
    document.addEventListener("message", ({ data }) => {
      if (typeof data === "string" && data.includes("notification")) {
        const objData = JSON.parse(data);
        if (objData?.name === "notification") {
          dispatch(fetchUnreadNotificationsSuccess(objData.notiCount));
          if (objData.isNavi) {
            navigate(objData.target);
          }
        }
      }
      // 안드로이드 뒤로가기 처리
      if (typeof data === "string" && data.includes("backAction")) {
        const objData = JSON.parse(data);
        if (objData?.name === "backAction") {
          const currentPath = location.pathname;
          const mainPath = [
            "/entrance",
            "/home",
            "/schedule",
            "/sales",
            "/store",
            "/all",
          ];
          if (mainPath.includes(currentPath)) {
            if (exitAppRef.current) {
              window.ReactNativeWebView.postMessage("exitApp");
            }
            exitAppRef.current = true;
            setTimeout(() => {
              exitAppRef.current = false;
            }, 2000);
            Toast(`뒤로가기 버튼을 한 번 더 누르면 종료됩니다.`, "", "76px");
          } else {
            history.back();
          }
        }
      }
    });

    window.addEventListener("androidNotiCount", async (event) => {
      dispatch(fetchUnreadNotificationsSuccess(event.detail.data || 0));
    });

    dispatch(updatePartnerInfo());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AppRoutes />
      <GlobalLoading />
      <GlobalSnackbar />
    </ThemeProvider>
  );
};

export default App;
